import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'REGISTER_ACTIONS';

export const {
    action: washHands,
    success: washHandsSuccess,
    failed: washHandsFailure,
} = createAction(`${domain}/WASH_HANDS`, (childIds: string[]) => ({
    childIds,
}));
